import { render, staticRenderFns } from "./SyntheseContacts.vue?vue&type=template&id=295b29d2&"
import script from "./SyntheseContacts.vue?vue&type=script&lang=js&"
export * from "./SyntheseContacts.vue?vue&type=script&lang=js&"
import style0 from "./SyntheseContacts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports